// player/bookings/BookingNew/api/mutations/newBooking.ts
import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const NEW_BOOKING_MUTATION = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  mutation newBooking(
    $bookingType: BookingType!
    $primaryBookerId: String!
    $attendees: [NewBookingAttendee!]!
    $teeTimeId: String
    $teeTimeType: BookingTeeTimeType
    $eventId: String
    $paymentMethodId: String
  ) {
    newBooking(
      input: {
        type: $bookingType
        primaryBookerId: $primaryBookerId
        attendees: $attendees
        teeTimeId: $teeTimeId
        teeTimeType: $teeTimeType
        eventId: $eventId
        paymentMethodId: $paymentMethodId
      }
    ) {
      ... on NewBookingOutput {
        booking {
          id
          purchase {
            ... on GetPurchaseOutput {
              purchase {
                id
                stripePaymentIntent
                clientSecret
                status
                receiptUrl
              }
            }
            ...UnauthenticatedError
            ...UnauthorizedError
            ...ServerError
          }
        }
        full
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
